// The docked shortcuts panel is z-index 1450. Editor dialogs must sit above it.
// Select menus must sit above those dialogs. A menu behind its dialog leaves
// the dialog visible but unable to take clicks or text.
export const EDITOR_DIALOG_Z_INDEX = 1600;
export const EDITOR_MENU_PROPS = { sx: { zIndex: 1800 } };
